import { Accessor, JSXElement, Setter, createContext, createSignal } from 'solid-js'
import { requireContext } from "common";

type Position = {
    x: number;
    y: number;
};

export class DraggableContext {
    floating: boolean = false;
    cloneHelper: boolean = false;
    hasHandle: Accessor<boolean>;
    setHasHandle: Setter<boolean>;
    isDragging: Accessor<boolean>;
    setIsDragging: Setter<boolean>
    helperElement: Accessor<HTMLDivElement | undefined>;
    setHelperElement: Setter<HTMLDivElement | undefined>;
    currentDropTarget: Accessor<HTMLElement | undefined>;
    setCurrentDropTarget: Setter<HTMLElement | undefined>;

    constructor() {
        [this.hasHandle, this.setHasHandle] = createSignal(false);  // Default to false, Handle component sets to true
        [this.isDragging, this.setIsDragging] = createSignal(false);
        [this.helperElement, this.setHelperElement] = createSignal<HTMLDivElement>();
        [this.currentDropTarget, this.setCurrentDropTarget] = createSignal<HTMLElement | undefined>();
    }
}

export const DraggableContextJsx = createContext<DraggableContext>();

export function requireDraggableContext() {
    return requireContext(DraggableContextJsx);
}
